import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-collapse';

const SidebarListItem = (props) => {
	const {
		acf,
		id,
		slug,
		selected,
		title,
		toggled,
		handleListItemClick,
		sidebarOpen,
	} = props;
	const { crb_excerpt: crbExcerpt } = acf;
	const isOpened = selected === id;
	const className = isOpened ? 'SidebarListItem selected' : 'SidebarListItem';
	const linkPath = toggled === 'trailheads' ? 'trailhead' : 'trail';
	const linkText =
		toggled === 'trailheads' ? 'Visit trailhead page' : 'Visit trip page';

	return (
		<li id={`list-item-${id}`} className={className}>
			<button
				className="more-info"
				tabIndex={sidebarOpen ? 0 : -1}
				aria-expanded={isOpened}
				aria-label={`${title.rendered} - ${isOpened ? 'collapse' : 'more information'}`}
				onClick={() => handleListItemClick(id)}
			>
				<p className="title">{title.rendered}</p>
				{!isOpened && (
					<p className="copy">
						More information{' '}
						<span className="arrow-right-small"></span>
					</p>
				)}
			</button>
			<Collapse className="list-item-collapsable" isOpened={isOpened}>
				<div aria-hidden={!isOpened}>
					<p>{crbExcerpt}</p>
					<p className="trailhead-page-link">
						<a
							aria-label={`Visit trailhead page for ${title.rendered} `}
							href={`/${linkPath}/${slug}`}
							tabIndex={isOpened && sidebarOpen ? 0 : -1}
						>
							{linkText}
						</a>
					</p>
				</div>
			</Collapse>
		</li>
	);
};

SidebarListItem.propTypes = {
	acf: PropTypes.object,
	handleListItemClick: PropTypes.func.isRequired,
	id: PropTypes.number,
	sidebarOpen: PropTypes.bool,
	slug: PropTypes.string,
	selected: PropTypes.number,
	title: PropTypes.object,
	toggled: PropTypes.string.isRequired,
};

export default SidebarListItem;



// WEBPACK FOOTER //
// ./map/components/SidebarListItem.js